import { from, Observable, of } from "rxjs";
import { ApplyEventStrategy, Command, CommandContext, CommandPage } from "controls";
import { RequestRoot } from "types";
import { concatMap } from "rxjs/operators";

export class SaveCommand implements Command<RequestRoot> {
    constructor(private date: Observable<Date>, private exit: boolean) {
    }

    icon(): string {
        return '';
    }

    caption(): string {
        return 'command.request.abandon';
    }

    color(): boolean {
        return false;
    }

    visible(ctx: CommandContext, selection: RequestRoot[], all: RequestRoot[]): boolean {
        return true;
    }

    enabled(ctx: CommandContext, selection: RequestRoot[]): boolean {
        return true;
    }

    execute(ctx: CommandContext, page: CommandPage, requests: RequestRoot[]): Observable<RequestRoot> {
        return from(requests).pipe(
            concatMap(x => page.isDirty() ? of(x): ctx.closeRequestWizard(page, false)),
            concatMap(x => ctx.validateRequestQuiet(page, x, this.date)),
            concatMap(x => ctx.applyRequestStatus(x.request, x.good ? 'READY' : 'DATA_ENTERED')),
            concatMap(x => ctx.removeRequestEvent(x, 'READY')),
            concatMap(x => ctx.applyRequestEvent(page, x, 'DATA_ENTERED', this.date, ApplyEventStrategy.ReplaceLastIfMultiple)),
            concatMap(x => x.status === 'READY' ? ctx.applyRequestEvent(page, x, 'READY', this.date, ApplyEventStrategy.ReplaceLastIfMultiple) : of(x)),
        ).pipe(
            concatMap(x => ctx.saveRequest(page, x)),
            concatMap(x => ctx.undirtyRequest(page, x)),
            concatMap(x => ctx.confirmRequestsAction(page, [x], 'fail.request.sitesucc', false)),
            concatMap(x => this.exit ? ctx.closeRequestWizard(page, false) : from([]))
        );
    }
}
